import { INIT, INIT_SUCCESS, INIT_FAILED, SAVE, SAVE_SUCCESS, SAVE_FAILED } from './constants';

export const initAction = (id, duplicate = false, isSurvey = false) => ({
  type: INIT,
  id,
  duplicate,
  isSurvey,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error, errorCode) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (form) => ({
  type: SAVE_SUCCESS,
  form,
});
export const saveFailedAction = (error, errorCode, additional) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});
